import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import SubstationManagement from '@/views/SubstationManagement'
import FileList from '@/views/FileList'
import View from '@/views/View'
import gis from '@/views/gis'
import store from "../store"

Vue.use(Router)

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: "",
      children: [
        {
            path: '/SubstationManagement',
            name: 'SubstationManagement',
            component: SubstationManagement
        },{
            path: '/FileList',
            name: 'FileList',
            component: FileList
        },{
          path: '/View',
          name: 'View',
          component: View
      },{
          path: '/gis',
          name: 'gis',
          component: gis
      },
      ]
    },{
      path: '/login',
      name: 'Login',
      component: Login,
  },
  ]


  const router = new Router({
      routes
  })

router.beforeEach((to, from, next) => {
  console.log(store.state.token.isLogin)
  if (store.state.token.isLogin || (to.path === '/login' )) {
    if (to.path == '/') {
      next('/login')
    } else {
        next()
    }
  } else {
    let parse = sessionStorage.getItem("token");
                
        if (parse && sessionStorage.getItem("isLogin")) {
            next()
        } else {
          next("/login")
          store.commit("clear")
          sessionStorage.clear()
        }
    
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js